import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en, id } from "./lang";

i18n.use(initReactI18next).init({
  resources: {
    en: en,
    id: id,
  },
  lng: "id",
  fallbackLng: "id",
  interpolation: {
    escapeValue: false,
  },
});
